import { useState, useEffect } from 'react';

interface Threshold {
  id: string;
  color: string;
  rating: string;
  logic: string;
  value: string | [number, number];
}

interface ChecklistData {
  isScoring?: boolean;
  scoreConfig?: Threshold[];
}

export const useChangeTracking = (
  isScoring: boolean,
  scoreConfig: Threshold[],
  checklist?: ChecklistData,
) => {
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [showImportantUpdate, setShowImportantUpdate] =
    useState<boolean>(false);

  // Track changes and show important update notification
  useEffect(() => {
    const originalIsScoring = checklist?.isScoring || false;
    const originalScoreConfig = checklist?.scoreConfig || [];

    const hasConfigChanges =
      isScoring !== originalIsScoring ||
      JSON.stringify(scoreConfig) !== JSON.stringify(originalScoreConfig);

    if (hasConfigChanges && !hasChanges) {
      setHasChanges(true);
      setShowImportantUpdate(true);
    }
  }, [isScoring, scoreConfig, checklist, hasChanges]);

  const resetChangeTracking = () => {
    setHasChanges(false);
    setShowImportantUpdate(false);
  };

  const dismissNotification = () => {
    setShowImportantUpdate(false);
  };

  return {
    hasChanges,
    showImportantUpdate,
    resetChangeTracking,
    dismissNotification,
  };
};
